import { ReactNode } from "react";
import { create } from "zustand";

interface StoreInterface {
  showModal: boolean;
  modalHeight?: number;
  modalWidth?: number;
  modalHeader?: ReactNode;
  modalContent?: ReactNode;
  shouldCloseOnOverlayClick: boolean;
  useDefaultUI: boolean;
  onClose?: () => void;
}

const BlankState: StoreInterface = {
  showModal: false,
  modalHeight: undefined,
  modalWidth: undefined,
  modalContent: undefined,
  shouldCloseOnOverlayClick: true,
  useDefaultUI: true,
  onClose: undefined
};

export default class ModalModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = ModalModel.useState.setState;
  static get state() {
    return ModalModel.useState.getState();
  }
  static reset() {
    ModalModel.setState({ ...BlankState });
  }

  static showModalWithContent(
    header?: ReactNode,
    content?: ReactNode,
    modalHeight?: number,
    modalWidth?: number,
    shouldCloseOnOverlayClick: boolean = true,
    useDefaultUI: boolean = true,
    onClose?: () => void
  ) {
    ModalModel.setState({
      showModal: true,
      modalHeight: modalHeight,
      modalWidth: modalWidth,
      modalHeader: header,
      modalContent: content,
      shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
      useDefaultUI: useDefaultUI,
      onClose: onClose
    });
  }
  static hideModal() {
    ModalModel.state.onClose?.();
    ModalModel.setState({
      showModal: false,
      onClose: undefined
    });
  }
}
